// extracted by mini-css-extract-plugin
export var pickupPadding = "index-module--pickupPadding--G_cmf";
export var pickupText = "index-module--pickupText--2sCRy";
export var pickup = "index-module--pickup--2u2NH";